module.exports = __webpack_public_path__ + "static/media/bsv.3722b7d6.png";